module.exports = __webpack_public_path__ + "static/media/globe-hands.4e07d004.png";